import { lazy as lazyLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    EditContactDetailsPage: lazyLoad(async () => {
        const { EditContactDetails } = await import('./EditContact');

        return { default: EditContactDetails };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.edit-contact-details.title',
        page: lazy.EditContactDetailsPage,
        path: route.patterns.individualUser.contactDetails.edit,
    },
];
